import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";
import { CouponState, CouponParams, CouponApiResponse } from "./CouponType";

export const fetchAsyncCoupon: any = createAsyncThunk<
  CouponParams,
  CouponApiResponse
>("Coupon/get", async () => {
  const response = await axiosSettings.get("api-admin/coupon/list");
  return response.data;
});

export const fetchAsyncCouponCreate: any = createAsyncThunk<
  CouponParams,
  CouponApiResponse
>("CouponCreate/post", async (formData: any) => {
  const response = await axiosSettings.post("api-admin/coupon", formData);
  return response.data;
});

const initialState: CouponState = {
  coupon: { validCoupon: null, invalidCoupon: null },
  loading: false,
  error: null,
  updatedTime: GetTime(),
  createdCoupon: null,
};

const CouponSlice = createSlice({
  name: "coupon",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncCoupon.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.updatedTime = GetTime();
        state.error = "";
        state.coupon["invalidCoupon"] =
          action.payload.data.result[0].invalid_coupon_list;
        state.coupon["validCoupon"] =
          action.payload.data.result[0].valid_coupon_list;
      } else {
        state.error = action.payload.data.result;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncCoupon.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncCoupon.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.msg;
    });
    //クーポン発行
    builder.addCase(fetchAsyncCouponCreate.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.createdCoupon = action.payload.data.result[0];
      }
    });
  },
});

export const couponInfo = (state: RootState) => state.Coupon.coupon;
export const couponLoading = (state: RootState) => state.Coupon.loading;
export const couponError = (state: RootState) => state.Coupon.error;
export const couponUpdatedTime = (state: RootState) => state.Coupon.updatedTime;
export const createdCoupon = (state: RootState) => state.Coupon.createdCoupon;
export default CouponSlice.reducer;
